export const AppVersionConstants = {
    GETAPPVERSION_REQUEST : 'GETAPPVERSION_REQUEST',
    GETAPPVERSION_SUCCESS : 'GETAPPVERSION_SUCCESS',
    GETAPPVERSION_FAILURE : 'GETAPPVERSION_FAILURE'
}


// WEBPACK FOOTER //
// ./src/store/constants/appVersion.constants.js